query GET_OWNER_FACILITIES ($id: UUID!) {
  owner(id: $id) {
    facility {
      id
      name
      status
      lots {
        name
        status
        isApproved
      }
      address {
        address1
        address2
        city
        state
        zipCode
      }
      amenities {
        id
        description
        iconName
        name
      }
    }
  }
}